import { IMinerHashSetting } from "./MinerHashSetting.props";
import cn from "classnames";
import styles from "./MinerHashSetting.module.scss";
import { useMinerHashSettingControl } from "./useMinerHashSettingControl";
import ColoredChanges from "../ColoredChanges/ColoredChanges";

export default function MinerHashSetting({ ...props }: IMinerHashSetting) {
  const { children } = props;
  const control = useMinerHashSettingControl(props);
  return (
    <div
      className={cn(styles.wrapper, {
        [styles.link]: control.canClick,
      })}
      onClick={control.canClick ? control.goToSetting : undefined}
    >
      <ColoredChanges>{children}</ColoredChanges>
    </div>
  );
}
